(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    root.MaleziaBundleBuilder = api;
    api.init(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var PAGE_SELECTOR = '.bundle-page';
  var LABEL_SELECTOR = '.rebuy-bundle-builder__action-box-label';
  var SUBSCRIBE_LABEL = 'Subscribe & Save';

  function cadenceMonths(label) {
    var text = String(label || '').trim();
    var match = text.match(/^Every\s+(?:(\d+)\s+)?months?\.?$/i);

    if (!match) return null;
    return match[1] ? Number(match[1]) : 1;
  }

  function normalizeSubscribeLabels(page) {
    var changed = false;

    page.querySelectorAll(LABEL_SELECTOR).forEach(function (label) {
      if (/^Sub\s*&\s*Save$/i.test(label.textContent.trim())) {
        label.textContent = SUBSCRIBE_LABEL;
        changed = true;
      }
    });

    return changed;
  }

  function normalizeCadenceSelect(select) {
    var options = Array.prototype.slice.call(select.options || []);
    var cadenceOptions = options.filter(function (option) {
      return cadenceMonths(option.textContent) !== null;
    });

    if (cadenceOptions.length < 2) return false;

    var orderedCadences = cadenceOptions.slice().sort(function (a, b) {
      return cadenceMonths(a.textContent) - cadenceMonths(b.textContent);
    });
    var alreadyOrdered = cadenceOptions.every(function (option, index) {
      return option === orderedCadences[index];
    });

    if (alreadyOrdered) return false;

    var cadenceIndex = 0;
    var desiredOrder = options.map(function (option) {
      if (cadenceMonths(option.textContent) === null) return option;
      return orderedCadences[cadenceIndex++];
    });

    desiredOrder.forEach(function (option) {
      select.appendChild(option);
    });

    return true;
  }

  function normalizeCadenceSelects(page) {
    var changed = false;

    page.querySelectorAll('.rebuy-bundle-builder__subscription-options select').forEach(function (select) {
      changed = normalizeCadenceSelect(select) || changed;
    });

    return changed;
  }

  function normalize(page) {
    normalizeSubscribeLabels(page);
    normalizeCadenceSelects(page);
    reconcileGifts(page);
  }

  /* ---- Free-gift guard ---------------------------------------------------
     Rebuy's Bundle Builder lets a shopper select every gift listed on a tier,
     offers gifts they already put in the bundle, and ships nothing if they
     never click "Select Gift". This layer sits on top of Rebuy's own data
     (window.Rebuy.widgets[n].data) so the storefront behaves like this:
       - a gift already in the bundle is hidden and never selected
       - exactly one gift visible  -> it is selected for them
       - two gifts visible         -> they pick one; picking swaps, never adds
       - no gift visible           -> no gift, with a note (the tier discount stands)
     A hard check runs again right before Rebuy builds the add-to-cart payload. */
  var GIFT_PREFERENCE = [
    8696545607905, // BHA/PHA Solution
    8080085549281, // Purified MCT Oil
    7180983664789  // Tube Key
  ];
  var GIFT_TEXT = {
    pick: 'Pick your free gift 🎁',
    one: 'Your free gift is in 🎁',
    none: 'Both gifts are already in your bundle — enjoy the 15% off 🎁'
  };
  var GIFT_CARD = '.rebuy-bundle-builder__gift-product';
  var GIFT_TITLE = '.rebuy-bundle-builder__gift-product-title';
  var GIFT_HEADER = '.rebuy-bundle-builder__gift-header';
  var GIFT_ADD_BUTTON = '.rebuy-bundle-builder__gift-product-button--add';
  var GIFT_POLL_MS = 250;
  var GIFT_POLL_LIMIT = 120;

  function giftRank(productId) {
    var index = GIFT_PREFERENCE.indexOf(Number(productId));
    return index === -1 ? GIFT_PREFERENCE.length : index;
  }

  function giftId(gift) {
    if (!gift) return null;
    var id = gift.product_id != null ? gift.product_id : gift.data && gift.data.id;
    return id == null ? null : Number(id);
  }

  // Pure: decide what the gift panel should look like for one tier.
  //   gifts     – tier gift entries ({product_id, data})
  //   products  – products currently in the bundle ({id})
  //   selected  – gift product ids currently marked selected
  //   lastChosen– gift product id the shopper clicked most recently (or null)
  function planGifts(gifts, products, selected, lastChosen) {
    var inBundle = {};
    (products || []).forEach(function (product) { inBundle[Number(product.id)] = true; });
    var chosen = {};
    (selected || []).forEach(function (id) { chosen[Number(id)] = true; });

    var entries = (gifts || []).map(function (gift) {
      var id = giftId(gift);
      return { id: id, hidden: Boolean(inBundle[id]), selected: Boolean(chosen[id]) };
    }).filter(function (entry) { return entry.id != null; });

    var visible = entries.filter(function (entry) { return !entry.hidden; }).sort(function (a, b) {
      return giftRank(a.id) - giftRank(b.id);
    });
    var picked = visible.filter(function (entry) { return entry.selected; });
    var keep = null;

    if (picked.length) {
      keep = picked.filter(function (entry) { return entry.id === Number(lastChosen); })[0] || picked[0];
    } else if (visible.length === 1) {
      keep = visible[0];
    }

    return {
      state: !entries.length ? 'off' : !visible.length ? 'none' : visible.length === 1 ? 'one' : 'pick',
      hide: entries.filter(function (entry) { return entry.hidden; }).map(function (entry) { return entry.id; }),
      deselect: entries.filter(function (entry) {
        return entry.selected && (!keep || entry.id !== keep.id);
      }).map(function (entry) { return entry.id; }),
      select: keep && !keep.selected ? keep.id : null,
      keep: keep ? keep.id : null
    };
  }

  function findBundleWidget(page) {
    var win = page.ownerDocument.defaultView;
    var widgets = win && win.Rebuy && win.Rebuy.widgets;
    if (!widgets || !widgets.length) return null;
    for (var i = 0; i < widgets.length; i++) {
      var widget = widgets[i];
      if (!widget || !widget.data || !widget.data.config) continue;
      if (widget.data.config.type !== 'bundle_builder') continue;
      if (!widget.View || !widget.View.vue) continue;
      if (page.querySelector('#rebuy-widget-' + widget.id)) return widget;
    }
    return null;
  }

  function tierGifts(widget) {
    var discount = widget.data.eligible_discount;
    return discount && Array.isArray(discount.gift_items) ? discount.gift_items : [];
  }

  function tierSelections(widget) {
    var map = widget.data.selected_gifts_map || {};
    var list = map[widget.data.eligible_discount_index];
    return Array.isArray(list) ? list : [];
  }

  function giftEntry(widget, id) {
    return tierGifts(widget).filter(function (gift) { return giftId(gift) === id; })[0] || null;
  }

  // Go through Rebuy's own handlers first so its view state stays coherent,
  // then make sure the data it reads at add-to-cart time agrees.
  function setGiftSelected(widget, id, selected) {
    var vue = widget.View.vue;
    var entry = giftEntry(widget, id);
    try {
      if (entry && entry.data) {
        if (selected && typeof vue.handleAddingGiftProduct === 'function') vue.handleAddingGiftProduct(entry.data);
        if (!selected && typeof vue.handleRemovingGiftProduct === 'function') vue.handleRemovingGiftProduct(entry.data);
      }
    } catch (error) {
      /* fall through to the data fix below */
    }
    tierSelections(widget).forEach(function (item) {
      if (Number(item.product_id) !== id) return;
      item.selected = selected;
      if (selected && entry && entry.data && entry.data.selected_variant && !item.variant_id) {
        item.variant_id = entry.data.selected_variant.id;
      }
    });
    var list = widget.data.selected_gifts;
    if (Array.isArray(list)) {
      var at = -1;
      list.forEach(function (product, index) { if (Number(product && product.id) === id) at = index; });
      if (!selected && at !== -1) list.splice(at, 1);
      if (selected && at === -1 && entry && entry.data) list.push(entry.data);
    }
  }

  function currentPlan(widget) {
    var selected = tierSelections(widget).filter(function (item) { return item.selected; })
      .map(function (item) { return Number(item.product_id); });
    return planGifts(tierGifts(widget), widget.data.products, selected, widget.__maleziaLastGift);
  }

  // A gift is a one-time item. In subscription mode Rebuy copies the gift's
  // selling plan onto the gift line, which would turn a free gift into a
  // recurring charge on renewal. Hand Rebuy a copy of the gift without plans;
  // the step products keep theirs.
  function hasSellingPlans(product) {
    if (!product) return false;
    if (product.selling_plan_groups && product.selling_plan_groups.length) return true;
    var variants = (product.variants || []).concat(product.selected_variant ? [product.selected_variant] : []);
    return variants.some(function (variant) {
      return (variant.selling_plans && variant.selling_plans.length) ||
        (variant.selling_plan_allocations && variant.selling_plan_allocations.length);
    });
  }

  function withoutSellingPlans(product) {
    function variant(source) {
      return Object.assign({}, source, { selling_plans: [], selling_plan_allocations: [] });
    }
    var copy = Object.assign({}, product, { selling_plan_groups: [] });
    if (Array.isArray(product.variants)) copy.variants = product.variants.map(variant);
    if (product.selected_variant) {
      copy.selected_variant = copy.variants && copy.variants.filter(function (item) {
        return item.id === product.selected_variant.id;
      })[0] || variant(product.selected_variant);
    }
    return copy;
  }

  function stripGiftSubscriptions(widget) {
    tierGifts(widget).forEach(function (gift) {
      if (!hasSellingPlans(gift.data)) return;
      var copy = withoutSellingPlans(gift.data);
      var list = widget.data.selected_gifts;
      if (Array.isArray(list)) {
        list.forEach(function (product, index) {
          if (Number(product && product.id) === giftId(gift)) list.splice(index, 1, copy);
        });
      }
      gift.data = copy;
    });
  }

  // Data pass: returns true when it changed something.
  function applyGiftPlan(widget, plan) {
    var changed = false;
    stripGiftSubscriptions(widget);
    plan.deselect.forEach(function (id) { setGiftSelected(widget, id, false); changed = true; });
    if (plan.select != null) { setGiftSelected(widget, plan.select, true); changed = true; }
    return changed;
  }

  // DOM pass: hide cards for gifts already in the bundle, retitle the panel.
  function paintGifts(page, widget, plan) {
    var gifts = tierGifts(widget);
    var cards = Array.prototype.slice.call(page.querySelectorAll(GIFT_CARD));
    var byTitle = {};
    gifts.forEach(function (gift) {
      if (gift.data && gift.data.title) byTitle[String(gift.data.title).trim()] = giftId(gift);
    });

    cards.forEach(function (card, index) {
      var title = card.querySelector(GIFT_TITLE);
      var id = title && byTitle[title.textContent.trim()];
      if (id == null && gifts[index]) id = giftId(gifts[index]);
      var hidden = plan.hide.indexOf(id) !== -1;
      // Rebuy's stylesheet sets display on the card, which beats the hidden attribute.
      if (card.hidden !== hidden) card.hidden = hidden;
      var display = hidden ? 'none' : '';
      if (card.style.display !== display) card.style.display = display;
      var mark = hidden ? 'hidden' : id === plan.keep ? 'selected' : 'available';
      if (card.getAttribute('data-malezia-gift') !== mark) card.setAttribute('data-malezia-gift', mark);
    });

    var header = page.querySelector(GIFT_HEADER);
    var text = GIFT_TEXT[plan.state];
    if (header && text && header.textContent.trim() !== text) header.textContent = text;
    if (page.getAttribute('data-malezia-gift-state') !== plan.state) page.setAttribute('data-malezia-gift-state', plan.state);
  }

  function reconcileGifts(page) {
    var widget = page.__maleziaBundleWidget;
    if (!widget || widget.__maleziaGiftBusy) return false;
    widget.__maleziaGiftBusy = true;
    var changed = false;
    try {
      var plan = currentPlan(widget);
      changed = applyGiftPlan(widget, plan);
      paintGifts(page, widget, changed ? currentPlan(widget) : plan);
    } catch (error) {
      /* never let the guard take the builder down with it */
    } finally {
      widget.__maleziaGiftBusy = false;
    }
    return changed;
  }

  // Selecting a second gift swaps it for the first instead of adding to it.
  function interceptGiftClicks(page) {
    page.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest(GIFT_ADD_BUTTON) : null;
      var widget = page.__maleziaBundleWidget;
      if (!button || !widget) return;
      var card = button.closest(GIFT_CARD);
      var title = card && card.querySelector(GIFT_TITLE);
      var id = null;
      tierGifts(widget).forEach(function (gift) {
        if (title && gift.data && String(gift.data.title).trim() === title.textContent.trim()) id = giftId(gift);
      });
      if (id == null) return;
      widget.__maleziaLastGift = id;
      tierSelections(widget).forEach(function (item) {
        if (item.selected && Number(item.product_id) !== id) setGiftSelected(widget, Number(item.product_id), false);
      });
    }, true);
  }

  // Last word before Rebuy reads selected_gifts_map to build the cart payload.
  function guardAddToCart(page, widget) {
    var win = page.ownerDocument.defaultView;
    var callbacks = win && win.Rebuy && win.Rebuy.callbacks;
    function hardCheck() {
      widget.__maleziaGiftBusy = false;
      reconcileGifts(page);
    }
    if (callbacks) {
      var previous = callbacks.beforeAddBundleToCart;
      callbacks.beforeAddBundleToCart = function (products, target) {
        if (!target || target === widget || target.id === widget.id) hardCheck();
        return typeof previous === 'function' ? previous.apply(this, arguments) : undefined;
      };
    }
    var vue = widget.View.vue;
    ['addSelectedProductsToCart', 'addSelectedProductsToCheckout'].forEach(function (name) {
      var original = vue[name];
      if (typeof original !== 'function') return;
      vue[name] = function () {
        hardCheck();
        return original.apply(this, arguments);
      };
    });
  }

  function watchGifts(page) {
    if (page.__maleziaGiftWatch) return;
    page.__maleziaGiftWatch = true;
    interceptGiftClicks(page);
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      var widget = findBundleWidget(page);
      if (!widget && attempts < GIFT_POLL_LIMIT) return;
      clearInterval(timer);
      if (!widget) return;
      page.__maleziaBundleWidget = widget;
      guardAddToCart(page, widget);
      reconcileGifts(page);
    }, GIFT_POLL_MS);
  }

  /* ---- Living sky hero -------------------------------------------------- */
  var SKY_SELECTOR = '[data-sky]';
  var SKY_STATES = ['morning', 'day', 'night'];
  var SKY_STORAGE_KEY = 'malezia:bundle-sky';
  var SKY_CAPTIONS = {
    auto: 'The sky follows your clock.',
    morning: 'Morning. Start light, protect early.',
    day: 'Midday. Keep it simple, keep it on.',
    night: 'Night. This is when skin does the work.'
  };

  function skyStateForHour(hour) {
    if (hour >= 5 && hour < 11) return 'morning';
    if (hour >= 11 && hour < 18) return 'day';
    return 'night';
  }

  function readStoredSky() {
    try {
      var value = sessionStorage.getItem(SKY_STORAGE_KEY);
      return SKY_STATES.indexOf(value) === -1 ? null : value;
    } catch (error) {
      return null;
    }
  }

  function storeSky(state) {
    try {
      sessionStorage.setItem(SKY_STORAGE_KEY, state);
    } catch (error) {
      /* private mode / storage disabled — the sky still works, it just won't remember */
    }
  }

  /* Cinematic plates: each <picture data-sky-plate> ships with data-src/data-srcset
     so the browser only fetches what we ask for. The section's inline script
     requests the first plate before paint; everything else goes through here. */
  function loadPlate(plate) {
    if (!plate || plate.hasAttribute('data-sky-loaded')) return Promise.resolve();
    plate.setAttribute('data-sky-loaded', '');
    plate.querySelectorAll('source[data-srcset]').forEach(function (source) {
      source.srcset = source.getAttribute('data-srcset');
    });
    var img = plate.querySelector('img[data-src]');
    if (!img) return Promise.resolve();
    function ready() { plate.setAttribute('data-sky-ready', ''); }
    img.addEventListener('load', ready, { once: true });
    img.src = img.getAttribute('data-src');
    if (typeof img.decode !== 'function') return Promise.resolve();
    return img.decode().then(ready, ready);
  }

  function platesFor(hero) {
    return Array.prototype.slice.call(hero.querySelectorAll('[data-sky-plate]'));
  }

  function preloadOtherPlates(hero) {
    var win = hero.ownerDocument.defaultView || {};
    var idle = win.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(function () {
      platesFor(hero).forEach(function (plate) { loadPlate(plate); });
    });
  }

  function applySky(hero, state, options) {
    var manual = options && options.manual;

    hero.querySelectorAll('[data-sky-set]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-sky-set') === state ? 'true' : 'false');
    });

    var caption = hero.querySelector('[data-sky-caption]');
    if (caption) caption.textContent = manual ? SKY_CAPTIONS[state] : SKY_CAPTIONS.auto;

    // Wait for the plate to decode so the crossfade lands on a finished frame,
    // but never hold the switch hostage to a slow network.
    var plate = hero.querySelector('[data-sky-plate="' + state + '"]');
    var settled = false;
    function commit() {
      if (settled) return;
      settled = true;
      hero.setAttribute('data-sky-state', state);
    }
    if (!plate || plate.hasAttribute('data-sky-loaded')) {
      commit();
    } else {
      loadPlate(plate).then(commit);
      setTimeout(commit, 900);
    }
  }

  // Desktop only: the sky and the twig answer the pointer at different depths.
  function initParallax(hero) {
    var win = hero.ownerDocument.defaultView;
    if (!win || !win.matchMedia) return;
    if (!win.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (win.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var queued = false;
    var px = 0;
    var py = 0;

    function paint() {
      queued = false;
      hero.style.setProperty('--sky-px', px.toFixed(3));
      hero.style.setProperty('--sky-py', py.toFixed(3));
    }

    hero.addEventListener('pointermove', function (event) {
      var rect = hero.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      px = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width) * 2 - 1));
      py = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height) * 2 - 1));
      if (!queued) {
        queued = true;
        win.requestAnimationFrame(paint);
      }
    });

    hero.addEventListener('pointerleave', function () {
      px = 0;
      py = 0;
      if (!queued) {
        queued = true;
        win.requestAnimationFrame(paint);
      }
    });
  }

  function initSky(hero, now) {
    if (hero.__maleziaSky) return;
    hero.__maleziaSky = true;

    var configured = hero.getAttribute('data-sky-default') || hero.getAttribute('data-sky-state') || 'auto';
    var stored = configured === 'auto' ? readStoredSky() : null;
    var date = now || new Date();
    var initial = SKY_STATES.indexOf(configured) !== -1
      ? configured
      : stored || skyStateForHour(date.getHours());

    applySky(hero, initial, { manual: Boolean(stored) || configured !== 'auto' });

    hero.querySelectorAll('[data-sky-set]').forEach(function (button) {
      button.addEventListener('click', function () {
        var state = button.getAttribute('data-sky-set');
        if (SKY_STATES.indexOf(state) === -1) return;
        applySky(hero, state, { manual: true });
        storeSky(state);
      });
    });

    if (hero.getAttribute('data-sky-style') === 'cinematic') {
      // WebKit renders SVG filters on the CPU; drop the cloud warp there.
      var nav = (hero.ownerDocument.defaultView || {}).navigator || {};
      if (/apple/i.test(nav.vendor || '')) hero.classList.add('bundle-sky--no-warp');
      preloadOtherPlates(hero);
      initParallax(hero);
    }
  }

  function observe(page) {
    if (page.__maleziaBundleObserver) return;

    watchGifts(page);
    normalize(page);

    if (typeof MutationObserver === 'undefined') return;

    var queued = false;
    page.__maleziaBundleObserver = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        normalize(page);
      });
    });
    page.__maleziaBundleObserver.observe(page, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // The hero fills the viewport below the site header so nothing else shows
  // above the fold. The header wraps to two lines at some widths, so measure it.
  function fitHeroToFold(doc) {
    var header = doc.getElementById('shopify-section-header');
    var heroes = doc.querySelectorAll(SKY_SELECTOR);
    if (!header || !heroes.length) return;
    var height = Math.round(header.getBoundingClientRect().height);
    heroes.forEach(function (hero) {
      hero.style.setProperty('--bundle-header-h', height + 'px');
    });
  }

  function init(doc) {
    function start() {
      doc.querySelectorAll(SKY_SELECTOR).forEach(function (hero) { initSky(hero); });
      doc.querySelectorAll(PAGE_SELECTOR).forEach(observe);
      fitHeroToFold(doc);
      var win = doc.defaultView;
      if (win) {
        win.addEventListener('resize', function () { fitHeroToFold(doc); });
        win.addEventListener('load', function () { fitHeroToFold(doc); }, { once: true });
      }
    }

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  return {
    cadenceMonths: cadenceMonths,
    normalizeCadenceSelect: normalizeCadenceSelect,
    normalizeSubscribeLabels: normalizeSubscribeLabels,
    planGifts: planGifts,
    giftRank: giftRank,
    hasSellingPlans: hasSellingPlans,
    withoutSellingPlans: withoutSellingPlans,
    skyStateForHour: skyStateForHour,
    initSky: initSky,
    init: init
  };
});
